export var EonAccountStatus;
(function (EonAccountStatus) {
    EonAccountStatus["EON_ACCOUNT_STATUS_UNSPECIFIED"] = "UNSPECIFIED";
    EonAccountStatus["EON_ACCOUNT_STATUS_ACTIVE"] = "ACTIVE";
    EonAccountStatus["EON_ACCOUNT_STATUS_ONBOARDING"] = "ONBOARDING";
    EonAccountStatus["EON_ACCOUNT_STATUS_REGISTRATION"] = "REGISTRATION";
    EonAccountStatus["EON_ACCOUNT_STATUS_INACTIVE"] = "INACTIVE";
})(EonAccountStatus || (EonAccountStatus = {}));
